module.exports = __webpack_public_path__ + "img/sentra4.2f614c46.jpeg";